import React, { Component, Fragment } from "react";
import { Grid, Checkbox, Typography, IconButton, Button, Paper } from '@material-ui/core';
import Link from "@material-ui/core/Link";
import LoadingIndicator from "../../common/loadingIndicator";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import AdvisorContext from "../context/context";
import { Tabs, Tab } from '@mui/material';
import ReactTable from "react-table";
import { ObjectivesGraph, TrendsGraph, DateRangePicker } from "./components";
import moment from "moment";
import Reporting from "../../common/reporting";

import "./index.css";


function containsAll(arr, target) {
    return target.every(element => arr.includes(element));
}
function calculateAgeInMonths(dateString) {
    const contDate = new Date(dateString);
    const currentDate = new Date();

    let ageInMonths = (currentDate.getFullYear() - contDate.getFullYear()) * 12;
    ageInMonths -= contDate.getMonth();
    ageInMonths += currentDate.getMonth();


    if (currentDate.getDate() < contDate.getDate()) {
        ageInMonths--;
    }

    return ageInMonths;
}
// Function to get the date 30 days before now
function getDate30DaysAgo() {
    const now = new Date();
    now.setDate(now.getDate() - 30);
    now.setHours(0, 0, 1, 0); // Set time to 1 second past midnight
    return now;
}

function getDate60DaysAgo() {
    const now = new Date();
    now.setDate(now.getDate() - 60);
    now.setHours(0, 0, 1, 0); // Set time to 1 second past midnight
    return now;
}

function getDate90DaysAgo() {
    const now = new Date();
    now.setDate(now.getDate() - 90);
    now.setHours(0, 0, 1, 0); // Set time to 1 second past midnight
    return now;
}


function generateRecentDates() {

    const dateRanges = [];
    const currentDate = new Date();
    const formattedDate = [

        String(currentDate.getMonth() + 1).padStart(2, '0'),
        String(currentDate.getDate()).padStart(2, '0'),
        currentDate.getFullYear(),
    ].join('/');

    const date30 = getDate30DaysAgo();
    const date60 = getDate60DaysAgo();
    const date90 = getDate90DaysAgo();
    const fmDt = formattedDate;
    dateRanges.push({
        label: ` Last 30 Days`,
        beginDate: date30,
        endDate: fmDt
    });
    dateRanges.push({
        label: ` Last 60 Days`,
        beginDate: date60,
        endDate: fmDt
    });
    dateRanges.push({
        label: ` Last 90 Days`,
        beginDate: date90,
        endDate: fmDt
    });

    return dateRanges;
}

function generateOlderDates() {
    const dateRanges = [];
    const OldDate = new Date('2000-01-01');

    const formattedDate = [
        String(OldDate.getMonth() + 1).padStart(2, '0'),
        String(OldDate.getDate()).padStart(2, '0'),
        OldDate.getFullYear(),
    ].join('/');

    const setToEndTime = (date) => {
        date.setHours(23, 59, 59);
        return date;
    };

    // Function to subtract one day
    const subtractOneDay = (date) => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() - 1);
        return newDate;
    };

    const date30 = subtractOneDay(setToEndTime(getDate30DaysAgo()));
    const date60 = subtractOneDay(setToEndTime(getDate60DaysAgo()));
    const date90 = subtractOneDay(setToEndTime(getDate90DaysAgo()));

    dateRanges.push({
        label: `More Than 30 Days`,
        beginDate: formattedDate,
        endDate: date30
    });
    dateRanges.push({
        label: `More Than 60 Days`,
        beginDate: formattedDate,
        endDate: date60
    });
    dateRanges.push({
        label: `More Than 90 Days`,
        beginDate: formattedDate,
        endDate: date90
    });

    return dateRanges;
}



function generateSchoolYears() {
    const currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    // If the current date is before September 1st, subtract one year
    if (currentDate < new Date(currentYear, 8, 1)) { // Months are 0-indexed
        currentYear--;
    }

    const dateRanges = [];
    for (let i = 0; i < 3; i++) {
        const beginDate = new Date(currentYear - i, 8, 1); // September 1st
        const endDate = new Date(currentYear - i + 1, 7, 31); // August 31st


        const formattedBeginDate = [

            String(beginDate.getMonth() + 1).padStart(2, '0'),
            String(beginDate.getDate()).padStart(2, '0'),
            beginDate.getFullYear(),
        ].join('/');

        const formattedEndDate = [

            String(endDate.getMonth() + 1).padStart(2, '0'),
            String(endDate.getDate()).padStart(2, '0'),
            endDate.getFullYear(),
        ].join('/');

        const label = `${currentYear - i} - ${currentYear - i + 1}`;

        dateRanges.push({
            label,
            beginDate: formattedBeginDate,
            endDate: formattedEndDate
        });
    }

    return dateRanges;
}



function getDateColor(dateString) {
    if (dateString == null || dateString == '') {
        return '';
    }
    const age = calculateAgeInMonths(dateString);

    switch (age) {
        case 0:
            return 'black';

        case 1:
            return 'gold';

        case 2:
            return 'darkorange';

        case 3:
            return 'red';

        default:
            return 'red';


    }

}



const preSelectedReportFields = ["userProfile.firstName", "userProfile.lastName", "userProfile.address1", "userProfile.address2", "userProfile.city", "userProfile.state", "userProfile.zipCode", "userProfile.email", "userProfile.mobilePhone"];
const skippedFields = ["advisor.deletionTime", "advisor.deleterUserId", "advisor.isDeleted", "school.district", "studentProfile.collegeId", "studentProfile.alien", "studentProfile.sasId", "studentProfile.ssn", "studentProfile.userProfileId", "userProfile.scholarshipCrusaders", "userProfile.workPhone", "userProfile.homePhone", "userProfile.emergencyContacts", "userProfile.isDeleted", "userProfile.deleterUserId", "userProfile.deletionTime", "userProfile.lastModificationTime", "userProfile.lastModifierUserId", "userProfile.creationTime", "userProfile.creatorUserId", "userProfile.domainEvents", "userProfile.id", "userProfile.userId", "userProfile.user", "userProfile.userType", "userProfile.cityId", "userProfile.bestTimeCallStart", "userProfile.primaryPhone", "userProfile.bestTimeCallEnd", "userProfile.highestLevelEducation", "userProfile.highestLevelEducationGrade", "userProfile.highestLevelEducationInUS", "userProfile.secondarySendCopy", "userProfile.schoolId", "userProfile.grade", "studentProfile.selectedInstitutionId", "studentProfile.selectedInstitutionModifiedDate", "studentProfile.otherInstitution", "studentProfile.isDeleted", "studentProfile.deleterUserId", "studentProfile.deletionTime", "studentProfile.lastModificationTime", "studentProfile.lastModifierUserId", "studentProfile.creationTime", "studentProfile.creatorUserId", "studentProfile.domainEvents", "studentProfile.id", "school.districtId", "school.userSettingSchools", "school.isActive", "school.domainEvents", "school.id", "advisor.userId", "advisor.user", "advisor.userType", "advisor.middleName", "advisor.address1", "advisor.address2", "advisor.city", "advisor.cityId", "advisor.state", "advisor.zipCode", "advisor.homePhone", "advisor.primaryPhone", "advisor.primaryLocale", "advisor.highestLevelEducation", "advisor.highestLevelEducationGrade", "advisor.highestLevelEducationInUS", "advisor.secondarySendCopy", "advisor.dateOfBirth", "advisor.schoolId", "advisor.citizenshipType", "advisor.hispanic", "advisor.race", "advisor.otherRace", "advisor.freeOrReducedLunch", "advisor.firstGeneration", "advisor.grade", "advisor.allergies", "advisor.medications", "advisor.medicalConditions", "advisor.dietaryRestrictions", "advisor.specialAccommodations", "advisor.scholarshipCrusaders", "advisor.emergencyContacts", "advisor.workPhone", "advisor.lastModificationTime", "advisor.lastModifierUserId", "family.primaryParent.grade", "family.primaryParent.firstGeneration", "family.primaryParent.freeOrReducedLunch", "family.primaryParent.race", "family.primaryParent.otherRace", "family.primaryParent.hispanic", "family.primaryParent.userId", "family.primaryParent.citizenshipType", "family.primaryParent.schoolId", "family.primaryParent.dob", "family.primaryParent.user", "family.primaryParent.userType", "family.primaryParent.cityId", "family.primaryParent.secondarySendCopy", "family.primaryParent.scholarshipCrusaders", "family.primaryParent.emergencyContacts", "family.primaryParent.isDeleted", "family.primaryParent.deleterUserId", "family.primaryParent.deletionTime", "family.primaryParent.lastModificationTime", "family.primaryParent.lastModifierUserId", "family.primaryParent.creationTime", "family.primaryParent.creatorUserId", "family.primaryParent.domainEvents", "family.primaryParent.id", "family.secondaryParent.grade", "family.secondaryParent.firstGeneration", "family.secondaryParent.freeOrReducedLunch", "family.secondaryParent.race", "family.secondaryParent.otherRace", "family.secondaryParent.hispanic", "family.secondaryParent.userId", "family.secondaryParent.citizenshipType", "family.secondaryParent.schoolId", "family.secondaryParent.dob", "family.secondaryParent.user", "family.secondaryParent.userType", "family.secondaryParent.cityId", "family.secondaryParent.secondarySendCopy", "family.secondaryParent.scholarshipCrusaders", "family.secondaryParent.emergencyContacts", "family.secondaryParent.isDeleted", "family.secondaryParent.deleterUserId", "family.secondaryParent.deletionTime", "family.secondaryParent.lastModificationTime", "family.secondaryParent.lastModifierUserId", "family.secondaryParent.creationTime", "family.secondaryParent.creatorUserId", "family.secondaryParent.domainEvents", "family.secondaryParent.id", "family.studentUserProfileId", "family.secondaryParent.highestLevelEducation", "family.secondaryParent.highestLevelEducationGrade", "family.secondaryParent.highestLevelEducationInUS", "family.secondaryParent.dateOfBirth", "family.primaryParent.dateOfBirth"];

class AdvisorObjectives extends Component {
    static contextType = AdvisorContext;
    constructor(props) {
        super(props);

        this.state = {
            advisorId: this.props.match.params.id,  
            advisor: [],
            loaded: false,
            students: [],
            objectives: [],
            stlist: [],
            total: 0,
            succeeded: 0,
            trend: [],
            beginDate: [],
            endDate: [],
            objs: [],
            datesList: [],
            fullStudents: [],
            fullTrend: [],
        };
    }



    componentDidMount = async () => {
        if (this.props.match && this.context.loaded) {
            await this.fetchData();
        }
    }


    componentDidUpdate = async (prevProps, prevState) => {

        if (!this.state.loaded && this.context.loaded )
            await this.fetchData();

        }


    fetchData = async () => {
        let students = [];
        let objectives = [];
        let trend = [];
        let total = 0;
        let succeeded = 0;
        let advisor = [];
        if (this.context.myBasics.subordinates.filter(flt => flt.userProfile.userId == this.props.match.params.id).length > 0) {
            advisor = this.context.myBasics.subordinates.filter(flt => flt.userProfile.userId == this.props.match.params.id)[0];
        } else {
            advisor = this.context.myBasics;
        }
        const tmp1 = this.context.myCases.filter(myCase =>
            myCase.allAdvisors == null && myCase.advisor.userId == this.props.match.params.id);
        //console.log(tmp1);
        const tmp2 = this.context.myCases.filter(myCase =>
            myCase.allAdvisors != null  ); 
        const tmp = tmp2.filter(myCase =>
            myCase.allAdvisors.some(advisor => advisor.userId == this.props.match.params.id)
        );
        tmp.push(...tmp1);
        //console.log(tmp);
        const objs = advisor.objectives
            .map(ob => ob.objectiveName) // First, get all objectiveNames
            .filter((value, index, self) => self.indexOf(value) === index); // Then filter out duplicates

        
        advisor.objectives.forEach(ob => {
            const appl = tmp.filter(flt => flt.studentProfile.currentGrade == ob.minGrade);
            let tot = 0;
            let success = 0;
            appl.forEach(st => {
           
                const tags = st.studentContactInfo.tags.filter(flt => flt.tagId == ob.tagsId && flt.subTagId == ob.subtagId);
                const status = tags.length > 0;
                tot++;
                total++;
                if (status) {
                    success++;
                    succeeded++;
                }

                tags.forEach(tag => {
                    const date = moment(tag.assignedDate).format("M/D/YY");
                    let existingTrend = trend.find(tr => tr.date === date);
                    if (existingTrend) {
                        existingTrend[ob.objectiveName] = existingTrend[ob.objectiveName] ? existingTrend[ob.objectiveName] + 1 : 1;
                    } else {
                        let newTrend = { date: date };
                        objs.forEach(obj => {
                            newTrend[obj] = 0
                        })
                        newTrend[ob.objectiveName] = 1;
                        trend.push(newTrend);
                    }
                });

                students.push({
                    displayName: st.userProfile.firstName + ' ' + st.userProfile.lastName,
                    currentGrade: st.studentProfile.currentGrade,
                    objectiveName: ob.objectiveName,
                    status: status,
                    lastServiced: st.studentContactInfo.lastContacted,
                    id: st.studentProfile.crusaderId,
                    userProfile: st.userProfile,
                    studentProfile: st.studentProfile,
                    school: st.school,
                    family: st.family,


                });
            });

            const existingObjectiveIndex = objectives.findIndex(obj => obj.displayName === ob.objectiveName);
            if (existingObjectiveIndex !== -1) {
                objectives[existingObjectiveIndex].total += tot;
                objectives[existingObjectiveIndex].metObjective += success;
            } else {
                objectives.push({
                    displayName: ob.objectiveName,
                    title: ob.displayName,
                    total: tot,
                    metObjective: success
                });
            }
        });

        const trSorted = trend.sort((a, b) => new Date(a.date) - new Date(b.date));
        this.setState({ objs: objs, trend: trSorted, fullTrend: trSorted, advisor: advisor, loaded: true, students: students, objectives: objectives, fullStudents: students, total: total, succeeded: succeeded });
    }
    onDateToggle = (dateRange) => {
        
        let dl = [...this.state.datesList];
        const sl = [];
        const tl = [];

        const dlf = dl.filter(flt => flt.label.trim() == dateRange.label.trim());
       

        if (dlf.length == 0) {
            dl.push(dateRange);
        } else {
            dl = this.state.datesList.filter(flt => flt.label.trim() != dateRange.label.trim());
        }

        
        if (dl.length > 0) {
            dl.forEach(ea => {
                // Set beginDate to start of the day
                const beginDate = new Date(ea.beginDate);
                beginDate.setHours(0, 0, 0, 0);
                const cutoff = new Date('1/2/2000');
                // Set endDate to end of the day
                const endDate = new Date(ea.endDate);
                endDate.setHours(23, 59, 59, 999);

                // Check if beginDate is January 1, 2000
                const isBeginDate2000 = beginDate < cutoff;
                if (isBeginDate2000) {
                   
                }
                const tlf = this.state.fullTrend.filter(flt => new Date(flt.date) >= beginDate && new Date(flt.date) <= endDate);
                const stf = this.state.fullStudents.filter(flt => new Date(flt.lastServiced) >= beginDate && new Date(flt.lastServiced) <= endDate);
                sl.push(...stf);
                tl.push(...tlf)
            });
        } else {
            sl.push(...this.state.fullStudents);
            tl.push(...this.state.fullTrend)
        }
       


        this.setState({ datesList: dl, students: sl, trend: tl });
    };

    toggleMessage = (newRecipient) => {



        // Check if the recipient is already in the array
        const isRecipientPresent = this.state.stlist.includes(newRecipient);

        // If the recipient is present, filter it out; if not, add it
        const updatedRecipients = isRecipientPresent
            ? this.state.stlist.filter(recipient => recipient !== newRecipient)
            : [...this.state.stlist, newRecipient];

        this.setState({ stlist: updatedRecipients });

    }

    handleSelectAll = async () => {
        let recip = this.state.stlist;

        if (containsAll(this.state.students, this.state.stlist) && this.state.stlist.length > 0) {


            recip = [];

        } else {

            recip = this.state.students;


        }

        
        this.setState({ recCount: recip.length, stlist: recip })
    }

    handleMassMessaging = () => {
        const ids = this.state.stlist.map(st => st.userProfile.id);

        const recipients = this.context.myCases.filter(caseItem =>
            ids.includes(caseItem.userProfile.id)
        );

        this.context.setRecipients(recipients);
        this.props.newMessage();
    }

    renderPercentage = () => {
        let total = 0;
        let achieved = 0;
       
            total = this.state.total;
            achieved = this.state.succeeded;
       

        let percentage = 0;
        try {
            if (total != 0) {
                percentage = ((achieved / total) * 100).toFixed(2);
            }

        } catch {

        }


        return (
            <Typography variant="h5" color="primary" gutterBottom>
                {percentage}%
            </Typography>
        );
    }

    renderName = () => {
        let name = this.context.myInfo.firstName + ' ' + this.context.myInfo.lastName;
        if (this.props.match && this.props.match.params.id != this.context.myBasics.userProfile.userId) {
            const adv = this.context.myBasics.subordinates.filter(flt => flt.userProfile.userId == this.props.match.params.id)
            name = adv[0].userProfile.firstName + ' ' + adv[0].userProfile.lastName;
        }
        return name;
    }
    

        render() {
            
            //console.log(this.context);
            if (!this.context.loaded) {
                return <LoadingIndicator />
            }
            let columns = [
                {
                    Header: () => (
                        <Checkbox
                            checked={this.state.students.length == this.state.stlist.length }
                            onChange={this.handleSelectAll}
                        />
                    ),
                    accessor: "id",
                    width: 50,
                    Cell: row => (
                        <Checkbox
                            onChange={() => this.toggleMessage(row.original)}
                            checked={this.state.stlist.includes(row.original)}
                        />
                    ),

                },
                {
                    Header: "Onward Id",
                    accessor: "id",
                    width: 100,
                    Cell: row => (
                        <div className="dataCell" style={{ display: "block", textAlign: "center" }} >{row.value}</div>
                    ),

                },

                {
                    Header: "Name",
                    accessor: "displayName",
                    Cell: row => (
                        <div className="dataCell" style={{ display: "block", textAlign: "center" }}>{row.value}</div>
                    ),

                },
                {
                    Header: "Objective",
                    accessor: "objectiveName",
                    Cell: row => (
                        <div className="dataCell" style={{ display: "block", textAlign: "center" }}>{row.value}</div>
                    ),

                },
                {
                    Header: "Status",
                    accessor: "status",
                    Cell: (row) => {
                        
                        const lCont = row.original.status == true ? "True" : "False";
                        return <div className="dataCell" style={{ display: "block", textAlign: "center" }}>{lCont}</div>;
                    },

                },
                {
                    Header: "Grade",
                    accessor: "currentGrade",
                    width: 75,
                    Cell: row => (
                        <div className="dataCell" style={{ display: "block", textAlign: "center" }}>{row.value}</div>
                    ),

                },
                {
                    Header: "Last Serviced",
                    accessor: "lastServiced",
                    Cell: (row) => {
                        const lCont = row.value !== null ? moment(row.value).format("M/D/YY h:mm a") : "";
                        return <div className="dataCell" style={{ display: "block", textAlign: "center", color: getDateColor(lCont), fontWeight: 'bold' }}>{lCont}</div>;
                    },

                },
                

            ];



            return (<Grid container spacing={3} style={{
                padding: '8px'
            }}>
                <Grid item xs={12} sm={2}>
                    <Link
                        className={"dashboardLink"} onClick={this.props.goBack}
                    >
                        &lt; Back
                    </Link><br />
                    {this.renderName()}
                </Grid>
                <Grid item xs={12} sm={7}>
                    <Typography variant="h5" color="secondary" gutterBottom align="center">
                        Objectives
                    </Typography>
                
                </Grid>
                <Grid item xs={12} sm={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <DateRangePicker
                        selectedDates={this.state.datesList}
                        onDateToggle={this.onDateToggle}
                    />
                </Grid>

                <Grid container xs={12} sm={10} style={{
                    display: 'flex', // Use flexbox layout
                    flexDirection: 'row',
                    height: '100%', // Take the full height available
                    justifyContent: 'flex-start', // Start alignment at the top for the first child
                    minHeight: '255px',
                    flexWrap: 'wrap',
                }}>
                    <Grid item sm={4} style={{
                        border: '1px solid #ccc', // Add border
                        boxSizing: 'border-box', // Ensure the border is included in the item's total width and height
                        minHeight: '255px',
                        padding: '8px'
}}>
                        <div style={{
                            display: 'flex', // Use flexbox layout
                            flexDirection: 'column', // Stack children vertically
                            height: '100%', // Take the full height available
                            justifyContent: 'flex-start', // Start alignment at the top for the first child
                        }}>
                            <div style={{
                                alignSelf: 'flex-start', // Align to the start of the flex container
                                width: '100%', // Ensure the div takes the full width
                                textAlign: 'center', // Center text horizontally
                                marginBottom: '0', // Remove any default bottom margin
                                paddingTop: '10px', // Space from the top of the container
                            }}>Objectives Met</div>
                            <div style={{
                                flex: 1, // Take up all available space
                                display: 'flex', // Use flexbox layout
                                flexDirection: 'column', // Stack children vertically
                                justifyContent: 'center', // Center vertically in the remaining space
                                textAlign: 'center', // Center text horizontally
                            }}>
                                {this.renderPercentage()}
                            </div>
                        </div>
                    </Grid>
                    {this.state.objectives.map(obj => {

                        return (<Grid item sm={4} style={{
                            border: '1px solid #ccc', // Add border
                            boxSizing: 'border-box', // Ensure the border is included in the item's total width and height
                            padding: '8px',
                            minHeight: '255px',
                        }}>
                            <ObjectivesGraph objective={obj} /></Grid>);
                    }) }
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Button
                        sx={{ my: 0.5 }}
                        variant="outlined"
                        size="small"
                        onClick={this.handleMassMessaging}

                        aria-label="move selected up"
                        className="headerActionButton"
                    >
                        Message
                    </Button>


                    <br /><br />
                    <Reporting data={this.state.stlist}
                        preSelected={preSelectedReportFields}
                        label="Export" doNotExport={skippedFields} className="headerActionButton" />

                    <br /><br />
                </Grid>


                <Grid item xs={12} sm={6}>
                    {
                        this.state.students.length > 0 ? (
                            <ReactTable
                                data={this.state.students}
                                minRows={0}
                                columns={columns}
                                defaultPageSize={50}
                                className="-striped -highlight tableWrapper"
                            />) : <span className="tableWrapper">{this.state.loaded ? "No students to display." : "Loading..."}</span>}

                </Grid>
                <Grid item xs={12} sm={6}>
                    <TrendsGraph data={this.state.trend} lines={this.state.objs } />

                </Grid>
                </Grid>                );
        }
 }





export default AdvisorObjectives;